"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _filterProps = require("../../internal/filterProps");
var _interactive = require("../../helpers/interactive");
var _tokens = require("../../tokens");
var _ = require("../../");
var _constants = require("./constants");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function (e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != typeof e && "function" != typeof e) return {
    default: e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n.default = e, t && t.set(e, n), n;
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
const StyledButtonBase = (0, _styledComponents.default)(_ref => {
  let {
    tag,
    ...props
  } = _ref;
  if (props.to && !tag) console.warn('If `to` is specified in <Button> you must also specify a `tag`');
  const Element = tag ? tag : props.href ? 'a' : 'button';
  const filteredProps = (0, _filterProps.filterProps)({
    props,
    keys: ['stretch', 'wide', 'iconOnLeft', 'separateIcon', 'textAlignOnWrap', 'loading', 'flush']
  });
  return /*#__PURE__*/_react.default.createElement(Element, filteredProps);
}).withConfig({
  displayName: "StyledButtonBase",
  componentId: "sc-1f7j90g-0"
})(["", " margin:0;border:0;outline:0;font-family:", ";font-weight:", ";text-align:center;border-radius:4px;cursor:pointer;display:inline-flex;justify-content:center;align-items:center;text-align:", ";text-decoration:none;transition:background-color 0.1s ease-in,color 0.2s linear,var(--interactive-transition);&:hover{text-decoration:none;}&:disabled{pointer-events:none;user-select:none;}> *:not(:first-child){display:inline-block;flex-shrink:0;}", " ", " ", " ", " ", ""], _interactive.interactiveBoxShadowStyles, _tokens.FONT.FAMILY.BODY, _tokens.FONT.WEIGHT.MEDIUM, _ref2 => {
  let {
    textAlignOnWrap
  } = _ref2;
  return textAlignOnWrap;
}, _ref3 => {
  let {
    stretch
  } = _ref3;
  return stretch && `width: 100%;`;
}, _ref4 => {
  let {
    wide
  } = _ref4;
  return wide && `
    width: 100%;
    max-width: 320px;
  `;
}, _ref5 => {
  let {
    separateIcon
  } = _ref5;
  return separateIcon && `
    justify-content: space-between;
  `;
}, _ref6 => {
  let {
    iconOnLeft
  } = _ref6;
  return iconOnLeft && (0, _styledComponents.css)(["flex-direction:row-reverse;"]);
}, _ref7 => {
  let {
    disabled,
    loading
  } = _ref7;
  return disabled && !loading && `
    &:disabled {
      color: ${_tokens.COLOR.GREY.MEDIUM};
      background: ${_tokens.COLOR.GREY.LIGHT};
    }
  `;
});
const StyledIcon = _styledComponents.default.div.withConfig({
  displayName: "StyledIcon",
  componentId: "sc-1f7j90g-1"
})(["margin:0 -2px;"]);

/**
## Usage

```js
import { Button } from '@farewill/ui'

() => (
  <>
    <Button.Plain />
    <Button.Underline />
    <Button.Primary />
    <Button.Secondary />
    <Button.White />
    <Button.Bordered />
    <Button.BorderedDark />
    <Button.Danger />
  </>
)
```

### How to use this component

Use the button component to help users carry out an action like starting their will or saving their information. Write button text in sentence case, describing the action it performs.

Use a button group when two or more buttons are placed together.


#### Width

Buttons width can either fit the label text, be fixed at 320px or span the full width of the parent container.

Buttons on mobile should span full width of the screen.

#### Buttons with icons

Use buttons with icons to visually emphasise the action you want users to achieve. Only use buttons in combination with filled-in icons to allow for sufficient contrast between text and icon.

#### Colour

Yellow is used as the primary call to action across our products. Blue can be used as an alternative primary action, based on the judgement of the designer. Avoid using both together, instead use the appropriate ButtonGroup for your designs.

#### Accessibility

`Button.Bordered` does not meet accessibility contrast requirements. It is used in some old designs, but shouldn't be used in future work and updated to `Button.BorderedDark` when possible.
*/
const ButtonBase = _ref8 => {
  let {
    size,
    textAlignOnWrap,
    children,
    disabled,
    loading,
    forward,
    back,
    icon,
    iconMargin,
    iconOnLeft,
    ...props
  } = _ref8;
  let content = children;
  if (forward) {
    icon = /*#__PURE__*/_react.default.createElement(StyledIcon, {
      as: _.ArrowRightIcon,
      size: "M"
    });
  }
  if (back) {
    icon = /*#__PURE__*/_react.default.createElement(StyledIcon, {
      as: _.ArrowLeftIcon,
      size: "M"
    });
    iconOnLeft = true;
  }
  if (icon) {
    const margin = iconMargin !== null && iconMargin !== void 0 ? iconMargin : _constants.SIZE[size].iconMargin;
    if (typeof icon === 'function') {
      icon = /*#__PURE__*/_react.default.createElement(StyledIcon, {
        as: icon,
        size: "M"
      });
    }
    content = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", null, children), /*#__PURE__*/_react.default.createElement("span", {
      style: {
        width: _tokens.GTR[margin] || `${margin}px`
      }
    }), icon);
  }
  return /*#__PURE__*/_react.default.createElement(StyledButtonBase, _extends({
    size: size,
    disabled: disabled || loading,
    loading: loading,
    iconOnLeft: iconOnLeft,
    textAlignOnWrap: textAlignOnWrap
  }, props), content);
};
ButtonBase.defaultProps = {
  size: 'M',
  textAlignOnWrap: 'center'
};
var _default = exports.default = ButtonBase;